<template>
    <tab-users ref="UserTab" :is_admin_section="true" />
</template>

<script>
import TabUsers from '@/components/tabs/Users.vue';

export default {
    components: {
        TabUsers,
    },
    methods: {
        reloadTable() {
            this.$refs.UserTab.reloadTable();
        },
    },
};
</script>
